export const EDIT_REFERRAL_DATA = 'EDIT_REFERRAL_DATA'
export const SET_DATA_FOR_REFERRAL_TABLE = 'SET_DATA_FOR_REFERRAL_TABLE'
export const CLEAN_UP_REFERRAL_DATA = 'CLEAN_UP_REFERRAL_DATA'
export const SET_IS_REFERRAL_SENT = 'SET_IS_REFERRAL_SENT'
